import React, {useEffect, useRef, useState} from 'react';
import styles from './shHeader.module.scss';
import ShImage from "../../components/image/shImage";
import ShMenu from "../menu/shMenu";
import { useWindowWidth } from "@react-hook/window-size";
import { WINDOW_SIZE_SM } from "../../helper/constants/window_size";

const ShHeader = ( {   backgroundUrl = undefined,
                       backgroundMobileUrl = undefined,
                       teaserMp4 = null,
                       teaserWebm = null,
                       teaserMobileMp4 = null,
                       teaserMobileWebm = null,
                       showOverlaySVG = false,
                       children = null,
                       className="",
                       showShadow = true,
                       menuStyle = "light",
                       height="normal"} ) => {

    if (!backgroundMobileUrl) {
        backgroundMobileUrl = backgroundUrl;
    }

    const videoRef = useRef(null);
    const videoMobileRef = useRef(null);

    const width = useWindowWidth();

    const [ isPhone, setIsPhone ] = useState(false);

    useEffect(
        () => {
            setIsPhone(width <= WINDOW_SIZE_SM);
        },
        [ width ]
    );

    useEffect(
        () => {
            videoRef.current?.load();
        },
        [ teaserMp4 ]
    );

    useEffect(
        () => {
            videoMobileRef.current?.load();
        },
        [ teaserMobileMp4 ]
    );



    return <div className={(height === "normal" ? styles.header : styles.headerSmall) + " no-select p-relative " + className}>

        <div className={styles.headerBackgroundImage}>
            { !teaserMp4 && backgroundUrl && !isPhone && <ShImage width={1900} url={backgroundUrl} fluid={false} viewportWidth={true} /> }
            { !teaserMobileMp4 && backgroundUrl && isPhone && <ShImage width={1900} url={backgroundMobileUrl} fluid={false} viewportWidth={true} /> }

            { (teaserMp4 && !isPhone) &&
                <>
                    <video id={"teaserDesktop"} preload="metadata" ref={videoRef} loop muted autoPlay playsInline poster={backgroundUrl}>
                        <source src={teaserWebm} type="video/webm; codecs=vp9,vorbis" />
                        <source src={teaserMp4} type="video/mp4"/>
                    </video>
                </>
            }

            { (teaserMobileMp4 && isPhone) &&
                <>
                    <video id={"teaserMobile"} preload="metadata" ref={videoMobileRef} loop muted autoPlay playsInline poster={backgroundMobileUrl}>
                        <source src={teaserMobileWebm} type="video/webm; codecs=vp9,vorbis" />
                        <source src={teaserMobileMp4} type="video/mp4"/>
                    </video>
                </>
            }

            {showOverlaySVG &&
                <div className={styles.overlayImage}>
                    <ShImage url={"https://7h-strapi.s3.eu-central-1.amazonaws.com/xmas_background_5db86aba84.png"}
                             fullHeihght={true}
                             fullWidth={true}
                    />
                </div>
            }

        </div>

        {showShadow &&
            <>
                <div className={styles.headerBackgroundBottomGradient}/>
                <div className={styles.headerBackgroundLinearGradient} />
            </>
        }

        <div className={styles.headerMenu}>
            <ShMenu style={menuStyle} />
        </div>

        <div className={styles.headerContent}>
            <div className="container">
                { children}
            </div>
        </div>
    </div>;
};

export default ShHeader;
